module.exports = __webpack_public_path__ + "img/white-square.b8499bcd.svg";